import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import AuthModal from "@/components/AuthModal";
import Header from "@/sections/Header";
import Footer from "@/sections/Footer";

/** Direct /login route — opens the auth modal (useful for links & automation). */
export default function Login() {
  const navigate = useNavigate();
  const { user, loading } = useAuth();
  const [open, setOpen] = useState(true);
  const authedRef = useRef(false);

  useEffect(() => {
    if (!loading && user) navigate("/my-coins", { replace: true });
  }, [user, loading, navigate]);

  const onAuthed = () => {
    authedRef.current = true;
    navigate("/my-coins", { replace: true });
  };

  const onOpenChange = (o) => {
    setOpen(o);
    if (!o && !authedRef.current) navigate("/", { replace: true });
  };

  return (
    <div className="min-h-screen bg-[#050505] text-white">
      <Header />
      <main className="pt-40 pb-32 text-center" data-testid="login-page">
        <div className="font-mono text-[11px] uppercase tracking-[0.3em] text-[#cfff04] mb-3">
          // sign in
        </div>
        <h1 className="font-display font-black text-4xl sm:text-5xl uppercase tracking-tighter">
          Welcome back.
        </h1>
      </main>
      <AuthModal open={open} onOpenChange={onOpenChange} onAuthed={onAuthed} />
      <Footer />
    </div>
  );
}
